/** Default client-side cache window — matches mobile app feed freshness. */
export const FEED_FRESHNESS_MS = 60 * 1000;

export function isFeedFresh(fetchedAt, ttlMs = FEED_FRESHNESS_MS) {
  return typeof fetchedAt === "number" && Date.now() - fetchedAt < ttlMs;
}

/**
 * Returns true when a list fetch can be skipped (Redux thunk `condition`).
 * Pagination, append, and explicit `force` always refetch.
 */
export function shouldSkipCachedFeed({
  force = false,
  fetchedAt = null,
  hasData = false,
  page = 1,
  limit,
  cachedPage,
  cachedLimit,
  append = false,
  ttlMs = FEED_FRESHNESS_MS,
} = {}) {
  if (force) return false;
  if (append || page > 1) return false;
  if (!hasData || !isFeedFresh(fetchedAt, ttlMs)) return false;
  if (cachedPage != null && page !== cachedPage) return false;
  if (cachedLimit != null && limit != null && limit !== cachedLimit) return false;
  return true;
}

export function parseUserIdArg(arg) {
  if (arg && typeof arg === "object") {
    return {
      userId: arg.userId,
      force: Boolean(arg.force),
    };
  }
  return { userId: arg, force: false };
}
